
import request from "@/utils/request";
const qs = require('qs');
//上传图片-公有
export function publicUpload(data) {
    return request({
      url: 'zwb/app/oss/public/upload',
      method: 'post',
      data
    })
}

//获取省市区
export function region(params) {
    return request({
      url: 'zwb/app/get/region',
      method: 'get',
      params
    })
}

//获取行业分类列表
export function getDict(params) {
    return request({
      url: 'zwb/app/get/dict',
      method: 'get',
      params
    })
}

//获取账户基本信息
export function getUsers(params) {
  return request({
    url: "/zwb/app/query/userinfo",
    method: "get",
    params
  });
}

//绑定手机
export function getBind(data) {
  return request({
    url: "/zwb/app/bind",
    method: "post",
    data
  });
}

//查询后台提现参数
export function getcashoutinfo() {
  return request({
    url: "/zwb/app/globle/cashout",
    method: "get",
  });
}
//根据name查询全局控制INFO
export function getcrtinfolist(params) {
  return request({
    url: "/zwb/app/get/globel/ctrolnameinfo",
    method: "get",
    params
  });
}

//查询我的资金账户余额+总收入+提现合计
export function myfunds(params) {
  return request({
    url: "/zwb/app/account/myfunds",
    method: "get",
    params
  });
}
//收入明细
export function incomeList(data) {
  return request({
    url: "/zwb/app/account/incomeList",
    method: "POST",
    data
  });
}
//提现明细
export function cashoutlist(data){
  return request({
    url: 'zwb/app/account/cashoutlist',
    method: 'post',
    data
  })
}

// 查询我的问题
export function getProblem(data) {
  return request({
    url: 'zwb/app/page/question',
    method: 'post',
    data
  })
}
// 查询可提问题状态
export function queryProblemauth(params) {
  return request({
    url: 'zwb/app/query/releasequestionauth',
    method: 'get',
    params
  })
}
// 添加问题
export function addProblem(data) {
  return request({
    url: 'zwb/app/release/question',
    method: 'post',
    data
  })
}
// 删除问题
export function delProblem(params) {
  return request({
    url: 'zwb/app/delete/question',
    method: 'get',
    params
  })
}
// 查看问题详情
export function viewProblem(params) {
  return request({
    url: 'zwb/app/get/question',
    method: 'get',
    params
  })
}

// 问题追问
export function minutely(data) {
  return request({
    url: 'zwb/app/examine/minutely',
    method: 'post',
    data
  })
}
//问题回答
export function answerQuestion(data) {
  return request({
    url: 'zwb/app/answer/question',
    method: 'post',
    data
  })
}

//发布需求
export function addDemand(data) {
  return request({
    url: 'zwb/app/release/demand',
    method: 'post',
    data
  })
}
//发布人力需求
export function addDemandRecruit(data) {
  return request({
    url: 'zwb/app/release/demandRecruit',
    method: 'post',
    data
  })
}
// 查询需求列表
export function getDemand(data) {
  return request({
    url: 'zwb/app/page/demandAll',
    method: 'post',
    data
  })
}
// 删除需求
export function delDemand(params) {
  return request({
    url: 'zwb/app/delete/demand',
    method: 'get',
    params
  })
}
// 查询需求详情
export function eitdDemand(params) {
  return request({
    url: 'zwb/app/get/demand',
    method: 'get',
    params
  })
}
// 关闭需求
export function closedDemand(params) {
  return request({
    url: 'zwb/app/close/demand',
    method: 'get',
    params
  })
}
// 删除需求
export function delDemandRecruit(params) {
  return request({
    url: 'zwb/app/delete/demandRecruit',
    method: 'get',
    params
  })
}
// 查询需求详情
export function eitdDemandRecruit(params) {
  return request({
    url: 'zwb/app/get/demandRecruit',
    method: 'get',
    params
  })
}
// 关闭需求
export function closedDemandRecruit(params) {
  return request({
    url: 'zwb/app/close/demandRecruit',
    method: 'get',
    params
  })
}

//(个人，专家，企业)购买课程
export function myCollegeList(data) {
  return request({
    url: 'zwb/app/college/myCollegeList',
    method: 'post',
    data
  })
}
//我的收藏
export function collectionList(data) {
  return request({
    url: 'zwb/app/account/collectionList',
    method: 'post',
    data
  })
}
//添加收藏
export function addCollection(data) {
  return request({
    url: 'zwb/app/account/addCollection',
    method: 'post',
    data
  })
}
// 取消收藏
export function cancelcollection(params) {
  return request({
    url: 'zwb/app/account/cancelcollection',
    method: 'get',
    params
  })
}
//删除收藏
export function delCollection(params) {
  return request({
    url: 'zwb/app/account/delCollection',
    method: 'get',
    params
  })
}
//添加资料
export function addMeans(data) {
  return request({
    url: 'zwb/app/mymeans/release',
    method: 'post',
    data
  })
}
//分页查询我的资料
export function meansList(params) {
  return request({
    url: 'zwb/app/mymeans/list',
    method: 'get',
    params
  })
}
//资料详情
export function getDetail(params) {
  return request({
    url: 'zwb/app/datacenter/myselfinfo',
    method: 'get',
    params
  })
}


//修改资料
export function editMeas(data) {
  return request({
    url: 'zwb/app/mymeans/modify',
    method: 'post',
    data
  })
}
//删除资料
export function delMeas(params) {
  return request({
    url: 'zwb/app/mymeans/delete',
    method: 'get',
    params
  })
}

//查询我的下载
export function myDownloadFile(data) {
  return request({
    url: 'zwb/app/account/myDownloadFile',
    method: 'post',
    data
  })
}
//查看下载详情
export function myDownloadDetail(params) {
  return request({
    url: 'zwb/app/account/myDownloadDetail',
    method: 'get',
    params
  })
}

//查询消息中心
export function mesList(data) {
  return request({
    url: 'zwb/app/msg/list',
    method: 'post',
    data
  })
}
//修改消息已读状态
export function mesStatus(params) {
  return request({
    url: 'zwb/app/msg/read',
    method: 'get',
    params
  })
}
//删除问题
export function delQuestion(params) {
  return request({
    url: 'zwb/app/delete/question',
    method: 'get',
    params
  })
}
//查看问题详情
export function viewQuestion(params) {
  return request({
    url: 'zwb/app/get/question',
    method: 'get',
    params
  })
}
//查询我的活动
export function activityList(data) {
  return request({
    url: 'zwb/app/myactivity/list',
    method: 'post',
    data
  })
}
//查询我的活动详情
export function activityInfo(params) {
  return request({
    url: 'zwb/app/activity/info',
    method: 'get',
    params
  })
}

//查询我的活动
export function activityJiCaiList(data) {
  return request({
    url: 'zwb/app/myactivityJiCai/list',
    method: 'post',
    data
  })
}
//查询我的活动详情
export function activityJiCaiInfo(params) {
  return request({
    url: 'zwb/app/activityJiCai/info',
    method: 'get',
    params
  })
}

//查看浏览人数
export function myBrowseList(data) {
  return request({
    url: 'zwb/app/account/myBrowseList',
    method: 'post',
    data
  })
}
//会员权益
export function authlist(params) {
  return request({
    url: 'zwb/app/get/authlist',
    method: 'get',
    params
  })
}
//获取服务列表
export function serverlist(params) {
  return request({
    url: 'zwb/app/get/serverlist',
    method: 'get',
    params
  })
}

//用户会员升级
export function member(data) {
  return request({
    url: 'zwb/app/certifi/vip/data',
    method: 'post',
    data
  })
}

//完善身份信息
export function card(data) {
  return request({
    url: 'zwb/app/certifi/card',
    method: 'post',
    data
  })
}

//升级会员费用
export function getVip(data) {
  return request({
    url: 'zwb/app/globle/vip',
    method: 'get',
    data
  })
}

//创建订单
export function createorder(data) {
  return request({
    url: 'zwb/app/account/createorder',
    method: 'post',
    data
  })
}


//提现订单参数
export function getcashoutparam() {
  return request({
    url: 'zwb/app/globle/cashout',
    method: 'get'
  })
}

//创建提现订单
export function createcashoutorder(data) {
  return request({
    url: 'zwb/app/account/cashout',
    method: 'post',
    data
  })
}

//支付宝pc端
export function alipay(data) {
  return request({
    url: 'zwb/app/pay/alipay/pc',
    method: 'post',
    data:qs.stringify(data)
  })
}
//微信支付
export function native(data) {
  return request({
    url: 'zwb/app/pay/wechat/native',
    method: 'post',
    data:qs.stringify(data)
  })
}

//查询订单状态
export function getorderstatus(data) {
  return request({
    url: 'zwb/app/account/getorderstatus',
    method: 'post',
    data:qs.stringify(data)
  })
}

//文件下载
export function download(params) {
  return request({
    url: 'zwb/app/oss/private/download',
    method: 'get',
    params
  })
}

//帮助中心
export function helpList(params) {
  return request({
    url: 'zwb/app/faq/list',
    method: 'get',
    params
  })
}
//帮助详情
export function helpDetail(params) {
  return request({
    url: 'zwb/app/faq/info',
    method: 'get',
    params
  })
}
//联系我们
export function linkus(data) {
  return request({
    url: 'zwb/app/aboutus/linkus',
    method: 'post',
    data
  })
}

//查询友情链接
export function link(params) {
  return request({
    url: 'zwb/app/globle/link',
    method: 'get',
    params
  })
}
//查询二维码
export function getQr(params) {
  return request({
    url: 'zwb/app/globle/qr',
    method: 'get',
    params
  })
}

//查询copy
export function copyright(params) {
  return request({
    url: 'zwb/app/globle/copyright',
    method: 'get',
    params
  })
}

//视频播放
export function vod(params) {
  return request({
    url: 'zwb/app/oss/private/vod',
    method: 'get',
    params
  })
}

// 企业专访视频播放
export function interviewVod(params) {
  return request({
    url: "/zwb/app/enterpriseInterview/private/vod",
    method: 'get',
    params
  })
}


//余额充值
export function recharge(params) {
  return request({
    url: 'zwb/app/account/recharge',
    method: 'get',
    params
  })
}
//查看公司统计信息
export function getCount(params) {
  return request({
    url: 'zwb/app/company/count',
    method: 'get',
    params
  })
}
//查看联系方式
export function getusercontact(params) {
  return request({
    url: 'zwb/app/auth/getusercontact',
    method: 'get',
    params
  })
}
//查询资源是否已购买
export function alreadypurchase(params) {
  return request({
    url: 'zwb/app/account/alreadypurchase',
    method: 'get',
    params
  })
}
//查询我的收藏状态
export function iscollection(params) {
  return request({
    url: 'zwb/app/account/iscollection',
    method: 'get',
    params
  })
}
//环保管家
export function getkeeper(params) {
  return request({
    url: 'zwb/app/getkeeper',
    method: 'get',
    params
  })
}


//入驻协议
export function agreement(params) {
  return request({
    url: 'zwb/app/get/agreement',
    method: 'get',
    params
  })
}

//查询vip
export function upvip(params) {
  return request({
    url: 'zwb/app/query/upvip',
    method: 'get',
    params
  })
}

//查询账号类型
export function existchangtypelog(params) {
  return request({
    url: 'zwb/app/query/existchangtypelog',
    method: 'get',
    params
  })
}

//请求更换类型
export function changtype(params) {
  return request({
    url: 'zwb/app/query/changtype',
    method: 'get',
    params
  })
}

//查询订单信息
export function orderinfo(params) {
  return request({
    url: 'zwb/app/account/orderinfo',
    method: 'get',
    params
  })
}

//退款申请
export function sendrefund(params){
  return request({
    url: 'zwb/app/account/sendrefund',
    method: 'get',
    params
  })
}

//查询copy
export function cppermit(params){
  return request({
    url: 'zwb/app/globle/cppermit',
    method: 'get',
    params
  })
}

//增加浏览人数
export function addBrowse(data){
  return request({
    url: 'zwb/app/account/addBrowse',
    method: 'post',
    data
  })
}

//查询专家未回复的数量
export function expertCount(params){
  return request({
    url: 'zwb/app/question/expertunanswercount',
    method: 'get',
    params
  })
}

//查询站内未读信息的数量
export function unreadmsgcount(params){
  return request({
    url: 'zwb/app/query/myself/unreadmsgcount',
    method: 'get',
    params
  })
}

//查询用户名是否存在
export function usernameisexist(params){
  return request({
    url: 'zwb/app/get/usernameisexist',
    method: 'get',
    params
  })
}

//查询环学院商品的价格
export function getcurrentprice(params){
  return request({
    url: 'zwb/app/college/getcurrentprice',
    method: 'get',
    params
  })
}

//用户的反馈与申请
export function sendface(params){
  return request({
    url: 'zwb/app/account/sendface',
    method: 'get',
    params
  })
}


//用户的发票申请
export function sendinvoice(params){
  return request({
    url: 'zwb/app/account/sendinvoice',
    method: 'get',
    params
  })
}
//用户申请发票列表
export function getinvoicelist(data){
  return request({
    url: 'zwb/app/account/getinvoicelist',
    method: 'post',
    data
  })
}
// 项目列表
export function getproject(data){
  return request({
    url: `/zwb/app/project/list`,
    method: 'post',
    data
  })
}
// 项目详情
export function projectInfo(params){
  return request({
    url: '/zwb/app/project/info',
    method: 'get',
    params
  })
}

// 保存浏览记录
export function frontBrowseSave(data){
  return request({
    url: '/zwb/app/frontBrowse/save',
    method: 'post',
    data
  })
}












// WEBPACK FOOTER //
// ./src/api/coment.js